import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${SIZES['8']};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const GoalsCol = styled.div`
  min-width: 8%;
  font-size: ${SIZES['14']};
  text-align: ${props => props.align};
`;

const BarCol = styled.div`
  width: 100%;
  align-items: center;
`;

const Rect = styled.rect`
  transform-origin: 50% 50%;
  animation: expand;
  animation-duration: 1s;

  @keyframes expand {
    from {
      transform: scale(0, 1);
    }
    to {
      transform: scale(1, 1);
    }
  }
`;

const GoalsBarChart = ({ownGoals, againstGoals}) => {
  const maxGoals = Math.max(ownGoals, againstGoals);
  const ownGoalsWidth = Math.round((ownGoals / maxGoals) * 50);
  const againstGoalsWidth = Math.round((againstGoals / maxGoals) * 50);
  const ownGoalsX = 50 - ownGoalsWidth;

  return (
    <Wrapper>
      <Row>
        <GoalsCol align='left'>{ownGoals}</GoalsCol>
        <BarCol>
          <svg width='100%' height='4px' viewBox='0 0 100 4' preserveAspectRatio='none'>
            <rect x='0' y='1' width='100' height='2' fill={COLORS.lighterGrey} stroke='transparent' />
            <Rect x={ownGoalsX} y='0' width={ownGoalsWidth} height='4' fill={COLORS.lightGreen} stroke='transparent' />
            <Rect x='50' y='0' width={againstGoalsWidth} height='4' fill={COLORS.lightRed} stroke='transparent' />
          </svg>
        </BarCol>
        <GoalsCol align='right'>{againstGoals}</GoalsCol>
      </Row>
      <Row>
        <Typography variant='caption1'>Tore</Typography>
        <Typography variant='caption1'>Gegentore</Typography>
      </Row>
    </Wrapper>
  );
};

export default GoalsBarChart;
